import { render } from "./Work.vue?vue&type=template&id=13ab2ce9&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "./Work.vue?vue&type=style&index=0&id=13ab2ce9&scoped=true&lang=css"

import exportComponent from "C:\\untis\\dev\\others\\others-maria-gruber\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ab2ce9"]])

export default __exports__